<template>
  <div
    :id="'barCharts' + randomNumber"
    class="barCharts"
  ></div>
</template>

<script>
export default {
  name: "BarCharts",
  props: {
    xAxisData: Array,
    yAxisData: Array,
    yUnitType: String
  },
  data () {
    return {
      randomNumber: Date.now()
    }
  },
  mounted () {
    this.showCharts();
  },
  methods: {
    // 展示折线图
    showCharts () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('barCharts' + this.randomNumber));//也可以通过$refs.newCharts的方式去获取到dom实例。
      // 绘制图表
      myChart.setOption({
        color: ['#306ceb'],
        xAxis: {
          type: 'category',
          data: this.xAxisData,
          axisLabel: {
            color: '#fff',
            interval: 0, // 使x轴文字显示全
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false // 不显示网格线
          },
          axisLabel: {
            color: '#fff',
            formatter: (value, index) => {
              if (this.yUnitType === 'w') {
                return `${(value / 10000).toFixed(0)}w`
              } else if (this.yUnitType === 'k') {
                return `${(value / 1000).toFixed(0)}k`
              }
              return value
            }
          },
          axisLine: {
            show: true
          }
        },
        series: [
          {
            data: this.yAxisData,
            type: 'bar',
            //设置柱状图颜色渐变
            color: new this.$echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "#69dcfa"
                },
                {
                  offset: 1,
                  color: "#3838c9"
                }
              ]
            )
          }
        ],
        grid: {
          x: 40,
          y: 20,
          x2: 10,
          y2: 30
        },
      })
    }
  },
  watch: {
    'yAxisData': function (val) {
      this.showCharts()
    }
  },
}
</script>

<style scoped>
.barCharts {
  width: 330px;
  height: 145px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
